<template>
    <div class="discussion-sum">
        <div class="message-item">
            <div class="message-line">
                <div class="message-pic">
                    <img :src="userPicUrl" @error="handleImageError" alt=""/>
                </div>
                <div class="message-info">
                    <span class="message-name">{{ userName }}</span>
                </div>
                <time class="message-date">{{ discussCreatedAt }}</time>
            </div>
            <p
                class="message-depiction"
                v-html="discuss.content.replace(/\r?\n/g, '<br />')"
            ></p>
            <div class="message-button" @click="openComment">
                <div class="message-icon">
                    <img src="img/pic/message.png" alt=""/>
                </div>
                {{ commentCount }} 則留言
            </div>
        </div>
        <div :class="commentOpenClass">
            <div
                class="message-reply"
                v-for="discussComment in discussComments" :key="discussComment.id"
            >
                <div class="message-line">
                    <div class="message-pic">
                        <img
                            v-if="discussComment.User && discussComment.User.picUrl"
                            :src="discussComment.User.picUrl" alt=""
                        />
                    </div>
                    <div class="message-info">
            <span class="message-name">{{
                    discussComment.User && discussComment.User.name
                        ? discussComment.User.name
                        : ''
                }}</span>
                    </div>
                    <time class="message-date">{{
                            discussComment.createdAt
                        }}
                    </time>
                </div>
                <p
                    class="message-depiction"
                    v-html="discussComment.content.replace(/\r?\n/g, '<br />')"
                ></p>
            </div>

            <div class="message-reply" v-if="authCheck">
                <form action="course/discuss/comment" method="post">
                    <div class="discuss-comment">
                        <div class="message-user">
                            <div class="message-user-pic">
                                <img v-if="LoginUserPicUrl" :src="LoginUserPicUrl" alt=""/>
                            </div>
                            <div class="message-user-info">
                <span class="message-user-name">{{
                        LoginUserEmail
                    }}</span>
                            </div>
                        </div>
                        <textarea name="discussComment"></textarea>
                        <button class="discuss-comment-btn" type="submit">
                            留言
                        </button>
                    </div>
                    <input
                        type="hidden"
                        name="pageSlug"
                        :value="pageSlug"
                    />
                    <input type="hidden" name="discussId" :value="discuss.id"/>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        discuss: {},
        discussComments: {},
        discussCreatedAt: {
            type: String,
            default: '',
        },
        commentCount: {
            type: Number,
            default: 0,
        },
        LoginUserPicUrl: {
            type: String,
            default: '',
        },
        LoginUserEmail: {
            type: String,
            default: '',
        },
        pageSlug: {
            type: String,
            default: '',
        },
        authCheck: {
            type: Boolean,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: false,
        },
    },
    data() {
        return {
            commentOpenData: false,
            userPicUrl: '',
            userName: '',
        };
    },
    created() {
        this.userPicUrl = this.discuss.User?.picUrl ?? 'img/fanswoo-framework/admin/sidebar/headPortrait.jpg';
        this.userName = this.discuss.User?.name ?? '';
    },
    mounted() {
    },
    computed: {
        commentOpenClass() {
            return {
                'discussion-item': true,
                open: this.commentOpenData,
            };
        },
    },
    methods: {
        openComment() {
            this.commentOpenData = !this.commentOpenData;
        },
        handleImageError(event) {
            // eslint-disable-next-line no-param-reassign
            event.target.src = 'img/fanswoo-framework/admin/sidebar/headPortrait.jpg';
        },
    },
};
</script>
<style scoped lang="scss">
$maincolor : #72ca4a;

.discuss-comment {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    .message-user {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        margin-bottom: 1rem;
        @media (max-width: 549px) {
            flex-wrap: wrap;
        }
        .message-user-pic {
            flex: 0 0 40px;
            border-radius: 50%;
            overflow: hidden;
        }
        .message-user-info {
            flex: 1;
            padding-left: 1.5rem;
            .message-user-name {
                color: #333;
            }
        }
    }
    textarea {
        width: 100%;
        height: 100px;
        margin-bottom: 15px;
    }
    .discuss-comment-btn {
        display: block;
        width: 150px;
        height: 40px;
        color: white;
        background-color: $maincolor;
        border: none;
        border-radius: 3px;
        transition: 0.3s;
        &:hover {
            background: lighten($maincolor, 10%);
            transition: 0.3s;
        }
    }
}
</style>
